<script lang="ts">
	import { scooterStorage } from '../../stores/preferences';
	import { _CategoriesEnum } from '$lib/utils/Enums';
	import {resolveImageByUrlString} from "$lib/helpers/universalCategoryImageByUrlResolver";
	import Scooter from '$lib/images/svg/scooter.svelte';
	// categories to display
	export let categories;
	// default category type
	export let categoryType = _CategoriesEnum.universal;
	export let selected_scooter: any = null;

	const resolveUrl = (category) => {
		return categoryType === _CategoriesEnum.new
			? `nahradni-dily/${category.url}`
			: `pouzite-dily/${category.url}`;
	};
	
</script>

{#each categories as category}
	<a
		href={categoryType === _CategoriesEnum.universal
			? `/univerzalni-dily/${category.url}/`
			: `/skutr-${$scooterStorage.url}/${resolveUrl(category)}/`}
		class="relative flex h-28 w-full items-center justify-start gap-x-6 border border-gray-geyser px-10 py-4 text-left shadow-sm transition hover:shadow-lg md:gap-x-10"
		title="{category.name} pro skútr{selected_scooter != null ? ' ' + selected_scooter.producer + ' ' 
		+ selected_scooter.name + ', ' + (selected_scooter.ccm !== '0' ? selected_scooter.ccm + ' ccm' : 'elektro') : ''}"
	>
		{#if category.url === 'originalni'}
			<div
				class="absolute left-0 top-0 rounded-bl-lg bg-red px-2 py-1 text-xs font-bold text-white"
			>
				Nový
			</div>
		{/if}

		<img
			src="{resolveImageByUrlString(category.url)}"
			class="inline-block h-16"
			alt={category.url}
		/>

		<h2 class="text-lg font-bold">
			{category.name}
			{#if category.amount > 0}
				({category.amount})
			{/if}
		</h2>
	</a>
{/each}
